export default {"src":"/_next/static/media/vision_about.1f66ca35.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};